<template>
    <div v-loading="loading">
        <div class="row mb-2" v-if="validationErrors.apiError">
            <div class="col">
                <el-alert type="error" >
                {{ validationErrors.apiError }}
                </el-alert>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <base-input
                type="text"
                label="Name *"
                placeholder="Name"
                v-model="form.name"
                @input="$delete(validationErrors, 'name')"
                >
                  <template slot="error" v-if="validationErrors.name">
                      <div class="invalid-feedback" style="display: block;">
                          {{ validationErrors.name }}
                      </div>
                  </template>
                </base-input>
            </div>
            <div class="col-lg-6" v-if="!sessionId">
                <base-input
                label="Event Type"
                >
                  <el-select v-model="form.event_type" placeholder="Event Type">
                      <el-option value="">
                      </el-option>
                      <el-option
                      v-for="(label, key) in eventTypes"
                      :key="key"
                      :label="label"
                      :value="key">
                      </el-option>
                  </el-select>
                </base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <!--TODO use all_day to implement event date start and event date end-->
                    <label class="form-control-label">Event Date *</label>
                    <el-date-picker
                        v-model="form.event_date"
                        @input="$delete(validationErrors, 'event_date')"
                        type="date"
                        placeholder="Select date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                    ></el-date-picker>
                    <small v-if="validationErrors.event_date" class="text-danger">{{ validationErrors.event_date }}</small>

                    <div class="mt-2" v-if="isCorporateEvent">
                        <label class="form-control-label">
                            <input type="checkbox" v-model="form.date_flexible" @change="onDateFlexibleChange"> 
                            My event date is flexible
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if="isCorporateEvent">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group mb-0">
                            <label class="form-control-label">Start Time *</label>
                            <el-time-picker
                                v-model="form.start_time"
                                placeholder="Start Time"
                                format="HH:mm"
                                value-format="HH:mm"
                                style="width: 100%"
                                @change="onStartTimeChange"
                                @focus="$delete(validationErrors, 'start_time')"
                            >
                            </el-time-picker>
                            <small v-if="validationErrors.start_time" class="text-danger">{{ validationErrors.start_time }}</small>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group mb-0">
                            <label class="form-control-label">End Time *</label>
                            <el-time-picker
                                v-model="form.end_time"
                                placeholder="End Time"
                                format="HH:mm"
                                value-format="HH:mm"
                                style="width: 100%"
                                :picker-options="endTimePickerOptions"
                                @change="onEndTimeChange"
                                @focus="$delete(validationErrors, 'end_time')"
                            >
                            </el-time-picker>
                            <small v-if="validationErrors.end_time" class="text-danger">{{ validationErrors.end_time }}</small>
                        </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="mt-2" v-if="isCorporateEvent">
                        <label class="form-control-label">
                            <input type="checkbox" v-model="form.is_multi_day_event"> 
                            Multi day event
                        </label>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12" v-if="form.date_flexible && isCorporateEvent">
                <div class="form-group">
                <label class="form-control-label">Preferred Days</label>
                <div class="d-flex flex-wrap">
                    <label class="mr-3" v-for="day in weekDays" :key="day.value">
                    <input type="checkbox" v-model="form.preferred_days" :value="day.value" class="mr-1">
                    {{ day.label }}
                    </label>
                </div>
                </div>
            </div>
            <div class="col-lg-12" v-if="form.date_flexible && isCorporateEvent">
                <div class="form-group">
                <label class="form-control-label">Preferred Months</label>
                <div class="d-flex flex-wrap">
                    <label class="mr-3" v-for="month in preferredMonths" :key="month.value">
                    <input type="checkbox" v-model="form.preferred_months" :value="month.value" class="mr-1">
                    {{ month.label }}
                    </label>
                </div>
                </div>
            </div>
            <div class="col-lg-6">
                <base-input
                type="text"
                label="Estimated Guests *"
                placeholder="Estimated Guests"
                v-model="form.estimated_guests"
                @input="$delete(validationErrors, 'estimated_guests')"
                >
                  <template slot="error" v-if="validationErrors.estimated_guests">
                      <div class="invalid-feedback" style="display: block;">
                          {{ validationErrors.estimated_guests }}
                      </div>
                  </template>
                </base-input>
            </div>
            <div class="col-lg-6">
                <base-input
                type="text"
                label="Estimated Budget *"
                placeholder="Estimated Budget"
                v-model="form.estimated_budget"
                @input="$delete(validationErrors, 'estimated_budget')"
                >
                  <template slot="error" v-if="validationErrors.estimated_budget">
                      <div class="invalid-feedback" style="display: block;">
                          {{ validationErrors.estimated_budget }}
                      </div>
                  </template>
                </base-input>
            </div>
            <div class="col-lg-6">
                <base-input
                  label="Location"
                >
                  <el-select v-model="form.location_id" placeholder="Location">
                      <el-option
                        v-for="item in locationOptions"
                        :key="'location_' + item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <el-alert
                v-if="!leadEvent.is_pipeline_attached"
                title="Alert"
                type="info"
                description="This event is not currently synchronized with HubSpot. Clicking on the 'Save' button will update this event as a deal in HubSpot. You can change the deal stage using the 'Pipeline' button on the event list."
                show-icon>
                </el-alert>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 text-right">
                <a class="btn btn-primary" @click="saveLeadEvent">Save {{ isCorporateEvent ? '& Next' : '' }}</a>
            </div>
        </div>
    </div>
</template>
<script>
import {
  Select,
  Option,
  Alert,
  TimePicker,
  DatePicker,
  Notification,
} from "element-ui";
import { mapState } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import {eventTypes} from '@/../app.config';
import LeadEventService from '@/services/lead-event.service';
import settingService from '@/services/settings.service';
import leadEventService from "@/services/lead-event.service";
import leadEventFormMixin from '@/helpers/leadEventFormMixin';
import { EnquiryService } from "@/services";
import moment from 'moment';

export default {
  mixins: [leadEventFormMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [TimePicker.name]: TimePicker,
    [DatePicker.name]: DatePicker,
    [Notification.name]: Notification,
    datePicker,
  },
  props: {
    leadEvent:  {
      type: Object,
      required: true,
    },
    event_type: {
      type: String,
      required: false,
      default: ''
    },
    sessionId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      dateOptions: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        showClear: true,
        showClose: true,
        calendarWeeks: false,
        viewMode: 'days',
        minDate: false,
        maxDate: false,
      },
      weekDays: [
        { value: 'Mon', label: 'Mon' },
        { value: 'Tue', label: 'Tue' },
        { value: 'Wed', label: 'Wed' },
        { value: 'Thu', label: 'Thu' },
        { value: 'Fri', label: 'Fri' },
        { value: 'Sat', label: 'Sat' },
        { value: 'Sun', label: 'Sun' }
      ],
      preferredMonths: [
        { value: 'Jan', label: 'Jan' },
        { value: 'Feb', label: 'Feb' },
        { value: 'Mar', label: 'Mar' },
        { value: 'Apr', label: 'Apr' },
        { value: 'May', label: 'May' },
        { value: 'Jun', label: 'Jun' },
        { value: 'Jul', label: 'Jul' },
        { value: 'Aug', label: 'Aug' },
        { value: 'Sep', label: 'Sep' },
        { value: 'Oct', label: 'Oct' },
        { value: 'Nov', label: 'Nov' },
        { value: 'Dec', label: 'Dec' }
      ],
      form: {
        location_id: this.leadEvent.location_id || null,
        name: this.leadEvent.name,
        event_type: this.event_type || this.leadEvent.event_type,
        event_date: this.extractDateFromDateTime(this.leadEvent.event_start),
        event_start: this.leadEvent.event_start,
        event_end: this.leadEvent.event_end,
        start_time: this.extractTimeFromDateTime(this.leadEvent.event_start) || '10:00',
        end_time: this.extractTimeFromDateTime(this.leadEvent.event_end) || '22:00',
        all_day: this.leadEvent.all_day || false,
        is_multi_day_event: this.leadEvent.is_multi_day_event || false,
        date_flexible: this.leadEvent.is_date_flexible || false,
        preferred_days: this.leadEvent.preferred_days || [],
        preferred_months: this.leadEvent.preferred_months || [],
        estimated_guests: this.leadEvent.estimated_guests,
        estimated_budget: this.leadEvent.estimated_budget,
      },
      loading: false,
      validationErrors: {},
      locationOptions: [],
    };
  },
  created() {
    this.getLocationOptions();
    this.updateFormFromLeadEvent(this.leadEvent);
  },
  computed: {
    ...mapState("country/", {
      country: (state) => state.country || 'AU',
    }),
    eventTypes: () => eventTypes,
    isCorporateEvent() {
      return this.form.event_type === 'corporate';
    },
    timeValidationError() {
      if (this.form.start_time && this.form.end_time) {
        const startTime = new Date(`2000-01-01 ${this.form.start_time}`);
        const endTime = new Date(`2000-01-01 ${this.form.end_time}`);
        if (endTime <= startTime) {
          return 'End time must be after start time';
        }
      }
      return null;
    },
    endTimePickerOptions() {
      if (!this.form.start_time) {
        return {};
      }
      
      const [startHour, startMinute] = this.form.start_time.split(':').map(Number);
      
      return {
        disabledHours: () => {
          const hours = [];
          for (let i = 0; i < startHour; i++) {
            hours.push(i);
          }
          return hours;
        },
        disabledMinutes: (hour) => {
          if (hour === startHour) {
            const minutes = [];
            for (let i = 0; i <= startMinute; i++) {
              minutes.push(i);
            }
            return minutes;
          }
          return [];
        }
      };
    }
  },
  methods: {
    extractDateFromDateTime(dateTime) {
      if (!dateTime) return '';
      return moment.utc(dateTime).local().format('YYYY-MM-DD');
    },
    extractTimeFromDateTime(dateTime) {
      if (!dateTime) return '';
      return moment.utc(dateTime).local().format('HH:mm');
    },
    combineDateAndTime(date, time) {
      if (!date) return '';
      if (!time) return date;
      
      // Create a local datetime and convert to UTC
      return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
    },
    convertLocalTimeToUTC(date, time) {
      if (!date || !time) return '';

      // Create a local datetime and convert to UTC
      return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
    },
    updateEventDateTimes() {
        this.form.event_start = this.combineDateAndTime(this.form.event_date, this.form.start_time);
        this.form.event_end = this.combineDateAndTime(this.form.event_date, this.form.end_time);
    },
    onDateFlexibleChange() {
      if (!this.form.date_flexible) {
        this.form.preferred_days = [];
        this.form.preferred_months = [];
      }
      // Note: We don't clear event_date when flexible is checked
      // The event_date remains available for selection alongside flexible options
    },
    onStartTimeChange(value) {
      // If end time exists and is now earlier than start time, adjust it
      if (this.form.end_time && value) {
        const startTime = new Date(`2000-01-01 ${value}`);
        const endTime = new Date(`2000-01-01 ${this.form.end_time}`);
        
        if (endTime <= startTime) {
          // Set end time to 1 hour after start time
          const newEndTime = new Date(startTime.getTime() + 60 * 60 * 1000);
          this.form.end_time = newEndTime.toTimeString().substring(0, 5);
        }
      }
      this.updateEventDateTimes();
    },
    onEndTimeChange(value) {
      // Validate end time is after start time
      if (this.form.start_time && value) {
        const startTime = new Date(`2000-01-01 ${this.form.start_time}`);
        const endTime = new Date(`2000-01-01 ${value}`);
        
        if (endTime <= startTime) {
          // Reset end time if it's invalid
          this.$nextTick(() => {
            this.form.end_time = '';
          });
          return;
        }
      }
      this.updateEventDateTimes();
    },
    async saveLeadEvent() {
      // Validate mandatory fields
      this.validationErrors = {};
      let isValid = true;

      if (!this.form.name) {
        this.$set(this.validationErrors, 'name', 'Name is required.');
        isValid = false;
      }

      if (!this.form.event_date) {
        this.$set(this.validationErrors, 'event_date', 'Event Date is required.');
        isValid = false;
      }

      if (this.isCorporateEvent) {
        if (!this.form.start_time) {
          this.$set(this.validationErrors, 'start_time', 'Start Time is required.');
          isValid = false;
        }
        if (!this.form.end_time) {
          this.$set(this.validationErrors, 'end_time', 'End Time is required.');
          isValid = false;
        }
      }

      if (!this.form.estimated_guests) {
        this.$set(this.validationErrors, 'estimated_guests', 'Estimated Guests is required.');
        isValid = false;
      } else if (isNaN(this.form.estimated_guests)) {
          this.$set(this.validationErrors, 'estimated_guests', 'Estimated Guests must be a number.');
          isValid = false;
      }

      if (!this.form.estimated_budget) {
        this.$set(this.validationErrors, 'estimated_budget', 'Estimated Budget is required.');
        isValid = false;
      } else if (isNaN(this.form.estimated_budget)) {
          this.$set(this.validationErrors, 'estimated_budget', 'Estimated Budget must be a number.');
          isValid = false;
      }

      if (!isValid) {
        this.loading = false;
        return;
      }

      // Update event_start and event_end before saving
      this.updateEventDateTimes();
      
      // Create a copy of the form data for sending to server
      const formDataForServer = { ...this.form };
      
      // Convert local times to UTC before sending to server
      if (this.isCorporateEvent && this.form.start_time && this.form.event_date) {
        formDataForServer.event_start = this.convertLocalTimeToUTC(this.form.event_date, this.form.start_time);
      }
      if (this.isCorporateEvent && this.form.end_time && this.form.event_date) {
        formDataForServer.event_end = this.convertLocalTimeToUTC(this.form.event_date, this.form.end_time);
        formDataForServer.all_day = false;
      }
      
      this.loading = true;
      this.validationErrors = {};
      let self = this;

      formDataForServer.session_name = this.form.name;
      formDataForServer.direct_update = true;
      formDataForServer.is_date_flexible = this.form.date_flexible;
      formDataForServer.step = 1;

      // Ensure start_time and end_time are correctly formatted as YYYY-MM-DD HH:mm in UTC for both create and update
      if (this.isCorporateEvent && this.form.event_date) {
          if (formDataForServer.start_time) {
               // Parse as local time then convert to UTC
               let timePart = formDataForServer.start_time;
               if (timePart.length > 5) {
                   timePart = moment(timePart).format('HH:mm');
               }
               // Construct local datetime string, parse it (defaults to local), convert to UTC, format
               formDataForServer.start_time = moment(`${this.form.event_date} ${timePart}`).utc().format('YYYY-MM-DD HH:mm');
          }
          if (formDataForServer.end_time) {
               let timePart = formDataForServer.end_time;
               if (timePart.length > 5) {
                   timePart = moment(timePart).format('HH:mm');
               }
               // Construct local datetime string, parse it (defaults to local), convert to UTC, format
               formDataForServer.end_time = moment(`${this.form.event_date} ${timePart}`).utc().format('YYYY-MM-DD HH:mm');
          }
      }

      // If no session ID, create one first
      if (!this.sessionId) {
        // Find the location name from the options
        const selectedLocation = this.locationOptions.find(opt => opt.id === this.form.location_id);
        formDataForServer.location = selectedLocation ? selectedLocation.name : '';

        try {
          const createResponse = await LeadEventService.createEventSession(this.leadEvent.id, formDataForServer);
          // Extract session ID from the response. The response structure contains an event object which has an event_sessions array.
          // We take the last session from the array as the newly created one, or the first if there's only one.
          const sessions = createResponse.data.event.event_sessions;
          const newSessionId = sessions && sessions.length > 0 ? sessions[sessions.length - 1].id : null;
          
          if (!newSessionId) {
             throw new Error("Could not retrieve new session ID from server response.");
          }
          
          this.$emit('onSessionCreated', newSessionId);
          
          // After creating, call update to ensure consistency and triggers any update hooks
           await LeadEventService.updateEventSession(this.leadEvent.id, {
            ...formDataForServer,
            session_id: newSessionId,
            step: 1
          });

          await self.$store.dispatch("leads/getLeadEvents", self.leadEvent.lead_id);
          
          Notification.success({
            title: 'Success',
            message: 'Event details saved successfully!',
            type: 'success',
          });

          self.$emit('onSave');
          self.loading = false;
        } catch (error) {
          const message = error.response ? error.response.data.error.message : error.message;
          self.$set(self.validationErrors, 'apiError', message);
          self.loading = false;
        }
      } else {
        // Find the location name from the options
        const selectedLocation = this.locationOptions.find(opt => opt.id === this.form.location_id);
        formDataForServer.location = selectedLocation ? selectedLocation.name : '';

        LeadEventService.updateEventSession(this.leadEvent.id, {
          ...formDataForServer,
          session_id: this.sessionId,
          step: 1
        })
        .then(async () => {
          await self.$store.dispatch("leads/getLeadEvents", self.leadEvent.lead_id);
          
          Notification.success({
            title: 'Success',
            message: 'Event details saved successfully!',
            type: 'success',
          });
          
          self.$emit('onSave');
          self.loading = false;
        })
        .catch((error) => {
          self.$set(self.validationErrors, 'apiError', error.response.data.error.message);
          self.loading = false;
        });
      }
    },
    updateFormFromLeadEvent(leadEvent) {
      // Update form fields from leadEvent data, preserving existing values when new data is missing
      const safeUpdate = (currentValue, newValue) => {
        return (newValue !== null && newValue !== undefined && newValue !== '') ? newValue : currentValue;
      };

      let dataToUse = leadEvent;
      if (this.sessionId) {
        const sessions = leadEvent.event_sessions || leadEvent.eventSessions || [];
        const session = sessions.find(s => s.id === this.sessionId);
        if (session) {
          dataToUse = {
            ...leadEvent, // Fallback to leadEvent for missing fields
            ...session,
            event_start: session.start_time,
            event_end: session.end_time,
          };
        }
      } else {
        // If no session ID, use leadEvent data as fallback/defaults
         dataToUse = {
            ...leadEvent,
            // Ensure properties are mapped correctly if names differ between root and session logic
            // (In this case, most map directly, but explicit mapping can be added here if needed)
         };
      }

      // Location
      this.form.location_id = safeUpdate(this.form.location_id, dataToUse.location_id);

      // Basic event information
      this.form.name = safeUpdate(this.form.name, dataToUse.name);
      this.form.event_type = safeUpdate(this.form.event_type, this.event_type || dataToUse.event_type);
      this.form.event_date = safeUpdate(this.form.event_date, this.extractDateFromDateTime(dataToUse.event_start));
      this.form.event_start = safeUpdate(this.form.event_start, dataToUse.event_start);
      this.form.event_end = safeUpdate(this.form.event_end, dataToUse.event_end);
      this.form.start_time = safeUpdate(this.form.start_time, this.extractTimeFromDateTime(dataToUse.event_start)) || '10:00';
      this.form.end_time = safeUpdate(this.form.end_time, this.extractTimeFromDateTime(dataToUse.event_end)) || '22:00';
      this.form.all_day = dataToUse.all_day || false;

      let isMultiDayEvent = this.safeBooleanUpdate(dataToUse.is_multi_day_event);
      this.form.is_multi_day_event = safeUpdate(this.form.is_multi_day_event, isMultiDayEvent);

      // Date flexibility
      this.form.date_flexible = dataToUse.is_date_flexible || false;
      if (Array.isArray(dataToUse.preferred_days) && dataToUse.preferred_days.length > 0) {
        this.form.preferred_days = dataToUse.preferred_days;
      }
      if (Array.isArray(dataToUse.preferred_months) && dataToUse.preferred_months.length > 0) {
        this.form.preferred_months = dataToUse.preferred_months;
      }

      // Basic event details
      this.form.estimated_guests = safeUpdate(this.form.estimated_guests, dataToUse.estimated_guests);
      this.form.estimated_budget = safeUpdate(this.form.estimated_budget, dataToUse.estimated_budget);
      
      // HubSpot integration
      this.form.is_multi_day_event = this.safeBooleanUpdate(dataToUse.is_multi_day_event);

      console.log('Basic form updated with data:', this.form);
    },
    getLocationOptions() {
      leadEventService.getEventLocations(this.country)
        .then(response => {
          this.locationOptions = response.data.eventLocations;
          
          // After options are loaded, ensure the pre-selected location_id is properly displayed
          if (this.form.location_id) {
            this.$nextTick(() => {
              // Trigger reactivity to ensure the select displays the correct option
              const locationId = this.form.location_id;
              this.$set(this.form, 'location_id', locationId);
            });
          }
        })
        .catch(error => {
          console.error("Error fetching event locations:", error);
        });
    }
  },
  watch: {
    locationOptions: {
      handler(newOptions) {
        // When location options are loaded, ensure the selected location_id is properly set
        if (newOptions && newOptions.length > 0 && this.form.location_id) {
          // Force reactivity update to ensure the select shows the correct selection
          this.$nextTick(() => {
            const selectedLocationId = this.form.location_id;
            this.form.location_id = null;
            this.$nextTick(() => {
              this.form.location_id = selectedLocationId;
            });
          });
        }
      },
      immediate: false
    },
    leadEvent: {
      handler(newLeadEvent) {
        if (newLeadEvent) {
          // Update form when leadEvent prop changes (from parent fetching detailed data)
          this.updateFormFromLeadEvent(newLeadEvent);
        }
      },
      deep: true,
      immediate: false
    },
    sessionId: {
      handler(newSessionId) {
        this.updateFormFromLeadEvent(this.leadEvent);
      },
      immediate: false
    },
    selectedDealPipeline: function() {
      this.$nextTick(() => {
        // If the event type is not set, but the pipeline and stage are set and no mismatch,
        // do not change the pipeline and stage
        // This is to prevent the pipeline and stage from being reset when the event type is not set
        if (
          this.form.hubspot_deal_pipeline_id
        ) {
          return;
        }

        this.form.hubspot_deal_pipeline_id = this.selectedDealPipeline.id;
      });
    },
    'form.event_date': function (val) {
      this.updateEventDateTimes();
    },
    'form.start_time': function (val) {
      this.updateEventDateTimes();
    },
    'form.end_time': function (val) {
      this.updateEventDateTimes();
    },
    'form.event_type': function(newType, oldType) {
        console.log('Event type changed from', oldType, 'to', newType);
     // if the user genuinely changed the type and it's not one of the originally attached types…
      if (
        newType !== oldType &&
        this.leadEvent.attached_pipeline_types &&
        !this.leadEvent.attached_pipeline_types.includes(newType)
      ) {
        // mark the mismatch
        this.pipelineEventTypeMismatch = true;

        // pick the new, compatible pipeline & reset stage
        const pipeline = this.selectedDealPipeline;
        this.form.hubspot_deal_pipeline_id = pipeline.id;
        this.form.hubspot_deal_stage_id   = pipeline.stages[0].id;
      } else if (this.leadEvent.hubspot_deal_pipeline_id && this.leadEvent.hubspot_deal_stage_id) {
        // revert mismatch flag but leave whatever stage the user last chose
        this.pipelineEventTypeMismatch = false;
        this.form.hubspot_deal_pipeline_id = this.leadEvent.hubspot_deal_pipeline_id;
        this.form.hubspot_deal_stage_id =  this.leadEvent.hubspot_deal_stage_id;
      } else {
        // if the user is changing the event type and select appropriate pipeline.
        const pipeline = this.selectedDealPipeline;
        this.form.hubspot_deal_pipeline_id = pipeline.id;
        this.form.hubspot_deal_stage_id  = pipeline.stages[0].id;
      }

      // Clear the start and end time if event type is selected as wedding
      if (oldType === EnquiryService.EVENT_TYPE_CORPORATE && newType === EnquiryService.EVENT_TYPE_WEDDING) {
        this.form.start_time = '';
        this.form.end_time = '';
        this.form.all_day = false;
      }

      this.$emit('eventTypeChange', newType);
    }
  },
}
</script>